/**
 * actionFilters — qué es cada cosa en el Centro de acción.
 *
 * Un solo sitio decide qué cuenta como "seguimiento comercial", porque lo
 * preguntan tres: el filtro de la barra, la tarjeta (para saber si pinta el
 * detalle) y las pruebas.
 *
 * La respuesta NO se deduce en el navegador. El motor marca
 * `meta.followup_kind` — "scheduled" para el seguimiento programado,
 * "reply" para la tarjeta de responder a un mensaje entrante — porque son
 * dos trabajos distintos y solo el backend sabe cuál es cuál. Sin esa marca
 * la respuesta es "no": preferimos enseñar de menos que tratar un "responde
 * a este cliente" como si fuera una tarea de agenda.
 */

/** ¿Es el seguimiento comercial programado de un lead? */
export function isFollowUpAction(item) {
  return item?.type === "follow_up"
    && item?.meta?.followup_kind === "scheduled";
}

/**
 * Aplica el filtro de tipo de la barra superior.
 *
 * `all` no filtra. `followups` es un filtro de la interfaz —no un tipo del
 * backend— y acota "Leads" a los seguimientos programados. El resto son
 * tipos reales de `action_item.type`.
 */
export function matchesTypeFilter(item, typeFilter) {
  if (!typeFilter || typeFilter === "all") return true;
  if (typeFilter === "followups") return isFollowUpAction(item);
  return item?.type === typeFilter;
}
